export default "__VITE_ASSET__feU8CSO4__"